// import React, { useEffect, useState } from "react";
// import axios from "../../api/axiosAuth";
// import "../../style/MisAsignacionestudiante.css";

// /* =========================================
//    🌐 API BASE
// ========================================= */
// // const API =
// //   process.env.REACT_APP_API ||
// //   "http://localhost:5001/api/asignaciones-grupo";

// const API = process.env.REACT_APP_API || "http://3.236.217.225:5001/api/asignaciones-grupo";
// /* =========================================
//    📘 COMPONENTE
// ========================================= */
// const MisAsignaciones = () => {
//   const [asignaciones, setAsignaciones] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   /* =========================================
//      🚀 CARGA INICIAL
//   ========================================= */
//   useEffect(() => {
//     const user = JSON.parse(localStorage.getItem("user"));

//     if (!user || !user.documento) {
//       setError("⚠️ No se pudo identificar al estudiante.");
//       setLoading(false);
//       return;
//     }

//     fetchAsignaciones(user.documento);
//   }, []);

//   /* =========================================
//      📡 FETCH ASIGNACIONES
//   ========================================= */
//   const fetchAsignaciones = async (documento) => {
//     try {
//       console.log("📌 Consultando asignaciones estudiante:", documento);

//       const res = await axios.get(
//         `${API}/asignaciones-estudiante/${documento}`,
//         {
//           // 🔐 IMPORTANTE: ENVÍA COOKIE JWT
//           withCredentials: true,
//         }
//       );

//       console.log("📥 DATA:", res.data);
//       setAsignaciones(res.data || []);
//     } catch (err) {
//       console.error("❌ Error API:", err?.response?.data || err);

//       if (err?.response?.status === 401) {
//         setError("🔐 Sesión expirada. Por favor inicia sesión nuevamente.");
//       } else {
//         setError("❌ No se pudieron cargar tus asignaciones.");
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   /* =========================================
//      🖥️ RENDER
//   ========================================= */
//   if (loading) return <p className="info">⏳ Cargando asignaciones...</p>;
//   if (error) return <p className="error">{error}</p>;

//   if (!asignaciones.length) {
//     return (
//       <p className="info">📭 No tienes asignaciones registradas.</p>
//     );
//   }

//   return (
//     <div className="asignaciones-container">
//       <h2 className="titulo">📚 Mis Asignaciones</h2>

//       {asignaciones.map((item) => (
//         <div key={item.id} className="asignacion-card">
//           <h3>📘 {item.materia}</h3>

//           <p>
//             <strong>Profesor:</strong>{" "}
//             {item.profesor || "No asignado"}
//           </p>

//           <span className="badge">
//             Grado {item.grado} - Grupo {item.grupo}
//           </span>

//           {item.sede && (
//             <p className="sede">
//               <strong>Sede:</strong> {item.sede}
//             </p>
//           )}
//         </div>
//       ))}
//     </div>
//   );
// };

// export default MisAsignaciones;



//

import React, { useEffect, useState } from "react";
import axios from "../../api/axiosAuth";
import "../../style/MisAsignacionestudiante.css";
// 1. IMPORTAMOS LA API CENTRALIZADA
import { API } from "../config"; 

/* =========================================
   📘 COMPONENTE
========================================= */
const MisAsignaciones = () => {
  const [asignaciones, setAsignaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  /* =========================================
     🚀 CARGA INICIAL
  ========================================= */
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (!user || !user.documento) {
      setError("⚠️ No se pudo identificar al estudiante.");
      setLoading(false);
      return;
    }

    fetchAsignaciones(user.documento);
  }, []);

  /* =========================================
     📡 FETCH ASIGNACIONES
  ========================================= */
  const fetchAsignaciones = async (documento) => {
    try {
      console.log("📌 Consultando asignaciones estudiante:", documento);

      // 2. CORREGIDO: Usamos la ruta relativa. 
      // axiosAuth ya tiene la base (http://3.236.217.225/api)
      const res = await axios.get(
        `/asignaciones-grupo/asignaciones-estudiante/${documento}`,
        {
          withCredentials: true,
        }
      );

      console.log("📥 DATA:", res.data);
      setAsignaciones(res.data || []);
    } catch (err) {
      console.error("❌ Error API:", err?.response?.data || err);

      if (err?.response?.status === 401) {
        setError("🔐 Sesión expirada. Por favor inicia sesión nuevamente.");
      } else {
        setError("❌ No se pudieron cargar tus asignaciones.");
      }
    } finally {
      setLoading(false);
    }
  };

  /* =========================================
     🖥️ RENDER
  ========================================= */
  if (loading) return <p className="info">⏳ Cargando asignaciones...</p>;
  if (error) return <p className="error">{error}</p>;

  if (!asignaciones.length) {
    return (
      <p className="info">📭 No tienes asignaciones registradas.</p>
    );
  }

  return (
    <div className="asignaciones-container">
      <h2 className="titulo">📚 Mis Asignaciones</h2>

      {asignaciones.map((item) => (
        <div key={item.id} className="asignacion-card">
          <h3>📘 {item.materia}</h3>

          <p>
            <strong>Profesor:</strong>{" "}
            {item.profesor || "No asignado"}
          </p>

          <span className="badge">
            Grado {item.grado} - Grupo {item.grupo}
          </span>

          {item.sede && (
            <p className="sede">
              <strong>Sede:</strong> {item.sede}
            </p>
          )}
        </div>
      ))}
    </div>
  );
};

export default MisAsignaciones;